var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav',[_c('Logo',{staticClass:"desktop"}),_c('Nav'),_c('IconeCarrinho')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }